export class OrganizationData
{	
    name            : string;
    vatRegistration : number;
    municipality    : string;
    placeId         : number;
    zipCode         : string;
    address         : string;
    //addressNumber   : string;
    latitude        : number;
    longitude       : number;
	email           : string;
	phone           : string;
}